// extracted by mini-css-extract-plugin
export default {"statusBadge":"PriorityField_statusBadge__Qq735"};